import { classnames } from '@tailwindcss-classnames';

export const closeButton = classnames(
  'w-10',
  'h-10',
  'p-2',
  'text-white',
  'rounded-full',
  'bg-opacity-60',
  'bg-nzxt-light-grey-500',
  'cursor-pointer',
  'hover:bg-nzxt-light-grey-700',
  'hover:bg-opacity-60'
);

export const closeButtonWrapper = classnames(
  'fixed',
  'opacity-100',
  'top-10',
  'right-10',
  'z-20'
);
